import _, { get, size } from "lodash";
import { ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";
import { getCarrierLogo } from "../lib/carrier";

export const rowButtonClassName =
  "flex min-h-16 w-full items-center gap-3 px-4 py-3 text-left transition-colors hover:bg-surface-muted focus-visible:-outline-offset-2 active:bg-surface-pressed";

export const Row = ({ backgroundImageUrl, rowHeader, rowSubHeader }) => {
  return (
    <>
      <span
        aria-hidden
        style={{
          backgroundImage: `url("${backgroundImageUrl}")`,
        }}
        className="size-10 shrink-0 rounded-full border border-subtle bg-surface bg-cover bg-center bg-no-repeat"
      />
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="block truncate text-body-lg font-medium text-ink">
          {rowHeader}
        </span>
        <span className="block truncate text-body-lg text-ink-secondary">
          {rowSubHeader}
        </span>
      </span>
      <ChevronRight
        aria-hidden
        className="size-[18px] shrink-0 text-ink-secondary"
        strokeWidth={1.75}
      />
    </>
  );
};

const Carrier = ({
  carrier,
  config,
  setCarrier,
  step,
  nextStep,
  setIntegration,
}) => {
  // Check if the carrier has multiple integration options
  const integrations = get(carrier, "integrations", []);
  const hasMultipleIntegrations = size(integrations) > 1;

  const [stepName, setStepName] = useState(() => {
    if (hasMultipleIntegrations) {
      return "select-verification-method";
    }
    // if there is only one integration, we need to check if it is a policy lookup integration
    if (integrations.length === 1 && integrations[0].type === "L123") {
      return "policy-lookup";
    }
    // Default to login
    return "login";
  });

  useEffect(() => {
    if (!get(carrier, "defined")) {
      setStepName("manual-account");
    }
  }, [carrier]);

  carrier.image = getCarrierLogo(carrier);

  return (
    <button
      className={rowButtonClassName}
      onClick={() => {
        setIntegration(get(integrations, "0.integration")); // set as first integration as default
        nextStep(stepName);
        setCarrier({ carrier });
      }}
    >
      <Row
        backgroundImageUrl={carrier.image}
        rowHeader={carrier.name}
        rowSubHeader={carrier.domain}
      />
    </button>
  );
};

export default Carrier;
